import GuestRoute from './Guest'
import PrivateRoute from './Private'

const RoutesMiddleware = ({ component, exact, path, privated }) => {
  if (privated) {
    return (
      <PrivateRoute
        path={path}
        exact={exact}
        component={component}
      />
    )
  }

  return (
    <GuestRoute
      path={path}
      exact={exact}
      component={component}
    />
  )
}

export default RoutesMiddleware
